import { render, staticRenderFns } from "./AddPaqueteModal.vue?vue&type=template&id=28882164"
import script from "./AddPaqueteModal.vue?vue&type=script&lang=js"
export * from "./AddPaqueteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28882164')) {
      api.createRecord('28882164', component.options)
    } else {
      api.reload('28882164', component.options)
    }
    module.hot.accept("./AddPaqueteModal.vue?vue&type=template&id=28882164", function () {
      api.rerender('28882164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddPaqueteModal.vue"
export default component.exports